import { PublicType } from '@Shared.Angular/@types/core/contracts/constants/publicType';
import React, { useState } from 'react';
import ClipboardCopy from '../ClipboardCopy/ClipboardCopy';

export type Props = {
  targetTypeName: string;
  initialPublicType: PublicType | null;
  publicShareableUrl?: string;
  iframeTag?: string;
  onPublicTypeChange: (value: PublicType | null) => void;
};

const SetupSharingPanel = (props: Props) => {
  const {
    targetTypeName,
    initialPublicType,
    publicShareableUrl = '',
    iframeTag = '',
    onPublicTypeChange
  } = props;
  const [isShareable, setShareable] = useState(initialPublicType !== null);
  const [publicType, setPublicType] = useState(
    initialPublicType || PublicType.Public
  );
  const disabledClass = isShareable ? '' : ' disabled';
  const disabledSharingMessage = `Public sharing is not enabled for this ${targetTypeName}.`;
  const publicTypeDescription =
    publicType === PublicType.Public
      ? `Allow ${targetTypeName} to be viewed by anyone via external URL.`
      : `Allow ${targetTypeName} to be viewed by users associated with
                your organisation via external URL.`;

  const updatePublicType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setPublicType(value);
    onPublicTypeChange && onPublicTypeChange(isShareable ? value : null);
  };

  const toggleShareable = () => {
    onPublicTypeChange && onPublicTypeChange(isShareable ? null : publicType);
    setShareable(!isShareable);
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="sharing-panel">
      <p>
        By turning ON the public sharing option, this {targetTypeName} can be
        accessed by anyone on the internet by using the public URL.
      </p>
      <div className="sharing-toggle-container">
        <i className="fa-regular fa-globe"></i> &nbsp;
        <div className="switch">
          <label>
            Make this {targetTypeName} publicly shareable
            <input
              id="required"
              type="checkbox"
              className="clickable"
              checked={isShareable}
              onChange={toggleShareable}
            />
            <span className="lever"></span>
          </label>
        </div>
      </div>
      {isShareable && (
        <div>
          <div className="public-type-container">
            <input
              name="publicType"
              id="publicTypePublic"
              type="radio"
              value={PublicType.Public}
              checked={publicType === PublicType.Public}
              onChange={updatePublicType}
            />
            <label htmlFor="publicTypePublic">Public</label>
            <input
              name="publicType"
              id="publicTypeIntranet"
              type="radio"
              value={PublicType.Intranet}
              checked={publicType === PublicType.Intranet}
              onChange={updatePublicType}
            />
            <label className="ml-25" htmlFor="publicTypeIntranet">
              Require sign-in
            </label>
          </div>
          <div className="public-type-description">
            <i className="fa-light fa-circle-info"></i>
            <span>{publicTypeDescription}</span>
          </div>
        </div>
      )}
      <label>Public URL</label>
      <div
        className={'public-sharing-container' + disabledClass}
        onClick={() => handleCopy(publicShareableUrl)}
      >
        <textarea
          id="publicUrl"
          rows={1}
          disabled
          value={isShareable ? publicShareableUrl : disabledSharingMessage}
        />
        <ClipboardCopy copyText={publicShareableUrl} disabled={!isShareable} />
      </div>
      <label>Embed Code</label>
      <div
        className={'public-sharing-container' + disabledClass}
        onClick={() => handleCopy(iframeTag)}
      >
        <textarea
          id="embedCode"
          disabled
          value={isShareable ? iframeTag : disabledSharingMessage}
        />
        <ClipboardCopy copyText={iframeTag} disabled={!isShareable} />
      </div>
    </div>
  );
};

export default SetupSharingPanel;
